import MasterData from '../data/MasterData'
import { isJrThruTrain } from './TrainNumber'

export const stationNumberClass = (ekiNumber, themeName) => {
  if (themeName === 'train') {
    return `c-StationIcon-stationNumber${ekiNumber}-train`
  } else {
    return `c-StationIcon-stationNumber${ekiNumber}`
  }
}

export const stringsCount = (str) => {
	str = str.replace(/[｡-ﾟ]/g, 'K')
	var hex = ''
	for (var i = 0; i < str.length; i++) {
		hex += str.charCodeAt(i).toString(16)
	}
	return hex.length/2;
}

export const textLongClass = (str, length) => {
  if (stringsCount(str) >= length) {
    return '-text-long'
  } else {
    return ''
  }
}

export const apiTrainKindClass = (apiTrain)  => {
  if (MasterData.isOnJrStation(apiTrain.destination_station_id)) {
    return 'is_jr'
  } else if (MasterData.isOnToyokoToward(apiTrain.destination_station_id)) {
    return 'is_toyoko'
  } else if (MasterData.isOnMeguroToward(apiTrain.destination_station_id)) { 
    return 'is_meguro'
  } else {
    return `${MasterData.trainKindClassById(apiTrain.kind)}`
  }
}

export const tidTrainKindClass = (tidTrain)  => {
  if (
    MasterData.isOnJrStation(tidTrain.destination_station_id) || // 行き先がJR線内
    tidTrain.source === 'jr' || // JR TIDから取得したデータ
    (isJrThruTrain(tidTrain.train_number) && tidTrain.next_station_id === 28 && tidTrain.direction === 'down') // 武蔵小杉→羽沢横浜国大間の列車(相鉄TID由来)
  ) {
    return 'is_jr'
  } else if (tidTrain.source === 'tokyu' && tidTrain.train_line_id === 26001) { // train_line_idによる判別を優先
    return 'is_toyoko'
  } else if (tidTrain.source === 'tokyu' && tidTrain.train_line_id === 26002) {
    return 'is_meguro'
  } else if (MasterData.isOnToyokoToward(tidTrain.station_id) || MasterData.isOnToyokoToward(tidTrain.next_station_id)) { // train_line_idにより判定できない場合には在線駅の路線で判別
    return 'is_toyoko'
  } else if (MasterData.isOnMeguroToward(tidTrain.station_id) || MasterData.isOnMeguroToward(tidTrain.next_station_id)) { 
    return 'is_meguro'
  } else if (MasterData.isOnToyokoToward(tidTrain.destination_station_id)) { // 在線駅で判別できない場合には行き先駅の路線で判別
    return 'is_toyoko'
  } else if (MasterData.isOnMeguroToward(tidTrain.destination_station_id)) {
    return 'is_meguro'
  } else { // sotetsu
    return MasterData.trainKindClassById(tidTrain.train_kind_id)
  }
}
